/**
 * 字典 & 基本配置
 */
import { getDicts } from "@/api/system/dict/data";

const state = {
    // 玲珑支持的系统版本
    linglong_app_sup_sys:[]
}

const getters = {
    linglong_app_sup_sys(state){
        return state.linglong_app_sup_sys.map(item=>parseInt(item.dictValue))
    }
}

const mutations = {
    getLinglongAppSupSys(state){
        getDicts("linglong_app_sup_sys").then(res=>{
            if(200 == ~~res.status && !!res.datas){
                state.linglong_app_sup_sys = res.datas
            }
        })
    }
}

const actions = {
    getLinglongAppSupSys({commit}){
        commit("getLinglongAppSupSys")
    }
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}